import TableList from "@components/templates/tablelist";
import { HttpSystemList, HttpDelSystem, HttpUpdateStstemStatus } from "@/service/ucadm";
import compAdd from "./update";
import compOrgOption from './orgOption';
export default {
    components: {
        compAdd,
        compOrgOption
    },
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            formData: {
                search: {
                    // 没有默认查询条件时只查询激活的
                    IN_status:'1'
                }
            },
            Tools:{show: true},
            Searchs: {
                isEnterSearch: true,
                show: true,
                labelWidth: 90,
                data:{}
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpSystemList,
        handleOperates(params = "", type, batch) {
            if (batch) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning("请选择至少一条数据");
            }
            switch (type) {
                case "add":
                     this.$router.push({
                        name: "orgUpdate",
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: "orgUpdate",
                        params: { type: "edit" },
                        query: { id: params }
                    });
                    break;
                case "editOption":
                    this.operate = {
                        show: true,
                        width: 600,
                        title: '编辑组织配置',
                        id: params,
                        component: 'compOrgOption',
                        showFooter: false
                    }
                    break;
                case 'enable':
                case 'disable':
                    this.loading = true
                    HttpUpdateStstemStatus(params).then(res => {
                        this.$VMessage.success(res.message)
                        this.ajaxRequest(this.formData).then(res => {
                            this.dataList = res.data.content
                            this.loading = false
                        })
                    }, err => {
                        this.$VMessage.error(err.message)
                    })
                    break
                case "export":
                    this.handleWebfs(process.env.VUE_APP_APIURL_UC + '/api/v1/Organization/exportByFilters', { ...this.formData }, 'download');
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [
                {
                    label: "编辑",
                    show: true,
                    params: id,
                    operate: "edit"
                },
                {
                    label: "编辑组织配置",
                    show: this.handleAuth('uc.organization_option.set'),
                    // show: true,
                    params: id,
                    operate: 'editOption'
                },
                {
                    label: '停用',
                    show: row.status === 1,
                    params: {
                        id: id,
                        status: 2
                    },
                    operate: 'disable'
                },
                {
                    label: '启用',
                    show: row.status === 2,
                    params: {
                        id: id,
                        status: 1
                    },
                    operate: 'enable'
                }
                // {
                //     label: "删除",
                //     show: this.handleAuth('uc.organization.del'),
                //     params: id,
                //     operate: "del"
                // }
            ];
        }
    },
    computed: {
        getStatusList(){
            return [
                {
                    value:1,
                    label:'激活',
                    theme:"success"
                },
                {
                    value:2,
                    label:'停用',
                    theme:"warning"
                },
                {
                    value:3,
                    label:'关闭',
                }
            ]
        },
        ToolsData(){
            return [{
                label:'添加组织',
                operate:'add',
                theme:'primary',
                show:this.handleAuth('uc.organization.add')
            },{
                label:'导出',
                operate:'export',
                theme:'success',
                show:true
            }]
        },
        SearchsData() {
            return [
                {
                    label: "名称",
                    tag: "vInput",
                    key: "CN_name",
                    show: true
                },
                {
                    label: "状态",
                    tag: "vSelect",
                    key: "IN_status",
                    options:this.getStatusList,
                    show: true
                }
            ];
        },
        columns() {
            return [
                {
                    title: "操作",
                    width: 70,
                    render: this.getOperateNodes
                },
                {
                    title: "名称",
                    key: "name",
                    sortable: true
                },
                {
                    title: "code",
                    key: "code"
                },
                {
                    title: "状态",
                    key: "status",
                    render: (h, { row }) => this.findRenderLabel(this.getStatusList, row.status,'label',true),
                },
                {
                    title: "合同公司名称",
                    key: "companyName"
                },
                {
                    title: "公司地址",
                    key: "companyAddress"
                },
                {
                    title: "联系人",
                    key: "contactName"
                },
                {
                    title: "联系电话",
                    key: "contactTel"
                },
                {
                    title: "更新时间",
                    key: "updatedAt"
                }
            ];
        }
    }
};
